export const DEBUG_ID = '@polls/debug';

export enum ItemTypes {
  FIELD = 'field',
}

export const APPEARANCE_LIGHT = 'light';
export const APPEARANCE_DARK = 'dark';

export const THEME_DEFAULT = 'default';
export const THEME_TINKOFF = 'tinkoff';

export const TEMPLATE_POLL = 'poll';

export const TEMPLATE_DIALOG = 'dialog';
export const TEMPLATE_DIALOG_WEBVIEW = 'dialog_webview';
export const TEMPLATE_WEBVIEW = 'webview';

export const PROGRESS_BAR_NUMBERS = 'numbers';
export const PROGRESS_BAR_LINE = 'line';
export const PROGRESS_BAR_SEGMENT_LINE = 'segment_line';
export const PROGRESS_BAR_INVISIBLE = 'invisible';
export const PROGRESS_BAR_PERCENT = 'percent';

export const RATING_SLIDER_THEME_DEFAULT = 'DEFAULT';
export const RATING_SLIDER_THEME_BLUE = 'BLUE';
export const RATING_SLIDER_THEME_GREEN = 'GREEN';
export const RATING_SLIDER_THEME_ORANGE = 'ORANGE';
export const RATING_SLIDER_THEME_RED = 'RED';

export const AWARD_POINTS = 'AWARD_POINTS';
export const AWARD_SCORES = 'AWARD_SCORES';

export const RANDOMIZE_POLL_GROUPS = 'groups';
export const RANDOMIZE_POLL_ALL = 'all';

export const WELCOME_SIMPLE = 'WELCOME_SIMPLE';
export const WELCOME_MOBILE_STORIES = 'WELCOME_MOBILE_STORIES';

export const FINAL_CLICK_PAGE = 'FINAL_CLICK_PAGE';
export const FINAL_CLICK_PAGE_NEW = 'FINAL_CLICK_PAGE_NEW';
export const FINAL_CLICK_PAGE_COMPACT = 'FINAL_CLICK_PAGE_COMPACT';
export const FINAL_CLICK_PAGE_PICTURE = 'FINAL_CLICK_PAGE_PICTURE';
export const FINAL_MOBILE_STORIES = 'FINAL_MOBILE_STORIES';

export const TEXTAREA_TYPE_TEXT = 'TEXT';
export const TEXTAREA_TYPE_PHONE = 'PHONE';
export const TEXTAREA_TYPE_EMAIL = 'EMAIL';
export const TEXTAREA_TYPE_DATE = 'DATE';
export const TEXTAREA_TYPE_NUMBER = 'NUMBER';
export const TEXTAREA_TYPE_URL = 'URL';
export const TEXTAREA_TYPE_SINGLE_LINE_TEXT = 'SINGLE_LINE_TEXT';
export const TEXTAREA_TYPE_SINGLE_LINES_TEXT = 'SINGLE_LINES_TEXT';

export const MEDIAFILE_TYPES = [
  'MEDIA_FILE_IMAGE',
  'MEDIA_FILE_AUDIO',
  'MEDIA_FILE_VIDEO',
  'MEDIA_FILE_TEXT',
  'MEDIA_FILE_ANY',
] as const;

export const OTHERS_ANSWER = 'others';
export const NOT_APPLICABLE_ANSWER = 'not_applicable';

export const GOTO_FINAL_TYPE = 'final';
export const GOTO_GROUP_TYPE = 'group';
export const GOTO_QUESTION_TYPE = 'question';

export const AUTH_PROVIDER_INTERNAL = 'internal' as const;
export const AUTH_PROVIDER_WEBOFFICE = 'wo' as const;
export const AUTH_PROVIDER_TWORK = 'twork' as const;

export type AUTH_PROVIDER = typeof AUTH_PROVIDER_TWORK;
